<template>
  <div id="death_benefit" :class="cls">
    <h2>{{ this.message(this.$appdata.messages, "policy").label }}</h2>
    <input v-model="value" type="hidden" readonly />
    <b-row class="mb-3 justify-content-center">
      <b-input
        type="text"
        v-model="policyStr"
        @keyup="setPolicy"
        @keydown="adv"
        placeholder="Policy Value"
        ref="policyStr"
        :class="$appdata.input_col_class"
      />
      <div class="error" v-if="this.policyStr.length == 7 && $v.value.$invalid">
        The policy must have a value of at least ${{
          $v.value.$params.minValue.min.toLocaleString()
        }}.
      </div>
    </b-row>
  </div>
</template>
<script>
import { minValue } from "vuelidate/lib/validators";
import { compStyles } from "@/mixins/compStyles";
import { messaging } from "@/mixins/messaging";
import { navigation } from "@/mixins/navigation";
export default {
  props: ["active_key", "active_index"],
  mixins: [messaging, compStyles, navigation],
  data() {
    return {
      disp_key: 1,
      value: 0,
      valid: null,
      policyStr: "",
      cls: "component out",
    };
  },
  validations: {
    value: {
      minValue: minValue(50000),
    },
  },
  methods: {
    setPolicy() {
      var str = this.policyStr.replace(/\D/g, "");

      if (str.length == 0) {
        str = 0;
        this.value = 0;
        this.policyStr = "";
        this.validate();
        return;
      }

      this.policyStr = "$" + parseInt(str).toLocaleString();
      this.value = parseInt(str);
      this.validate();
    },
    validate: function () {
      if (!this.$v.value.$invalid) {
        this.$emit("setProp", { prop: "death_benefit", value: this.value });
        this.$emit("setProp", { prop: "nextDisabled", value: false });
      } else {
        this.$emit("setProp", { prop: "death_benefit", value: 0 });
        this.$emit("setProp", { prop: "nextDisabled", value: "disabled" });
      }
    },
    adv: function (event) {
      if (event.key == "Backspace") {
        this.$emit("setProp", { prop: "nextDisabled", value: "disabled" });
      } else if (event.key == "Enter" && !this.$v.value.$invalid) {
        this.incNext();
      }
    },
  },
  mounted: function () {},
  watch: {
    policyStr: function () {},
    active_key: function (n) {
      this.toggleActive(n);
      if (n == this.disp_key) {
        var t = this;
        setTimeout(function () {
          t.$refs.policyStr.focus();
          t.validate();
        }, 100);
      }
    },
  },
};
</script>
